import { z } from "zod";
export const NEWS_TYPES = ["warning", "info"];
export const newsItemSchema = z.object({
    id: z.string(),
    type: z.enum(NEWS_TYPES),
    title: z.string(),
    body: z.string(),
    publishedAt: z.string(),
});
//# sourceMappingURL=index.js.map